module.exports = {"360923001":"敖阳街道","360923100":"田心镇","360923101":"徐家渡镇","360923102":"锦江镇","360923103":"泗溪镇","360923104":"翰堂镇","360923105":"南港镇","360923106":"敖山镇","360923107":"新界埠镇","360923108":"蒙山镇","360923200":"芦洲乡","360923201":"塔下乡","360923203":"镇渡乡","360923204":"野市乡","360923206":"墨山乡","360923400":"上高县工业园区","360923501":"上甘山林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360923.json
// module id = 1320
// module chunks = 0